import { useRef } from "react";

export default function DemoCard({
  demo,
  cursor,
  activeDemo,
  setActiveDemo,
  flippingCard,
  setFlippingCard
}) {

  const cardRef = useRef(null);

  const isFlipping = flippingCard === demo.id;

  function handleClick() {

    setFlippingCard(demo.id);

    setTimeout(() => {
      setActiveDemo(demo);
    }, 350);
  }

  return (
    <div
      className="demo-card-wrapper"
      ref={cardRef}
      onClick={handleClick}
    >

      <div className={`demo-card-inner ${isFlipping ? "flipping" : ""}`}>

        <div className="demo-card-front">
          <div className="demo-preview">
            {demo.item}
          </div>
        </div>

        <div className="demo-card-back">
          Loading demo...
        </div>

      </div>

    </div>
  );
}